var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5441 20.1799H29.9121C31.5321 17.8279 31.2921 14.5879 29.2041 12.4999C26.8521 10.1479 23.0241 10.1479 20.6721 12.4999L20.0001 13.1599L19.3401 12.4999C18.2001 11.3599 16.6881 10.7239 15.0681 10.7239C13.4601 10.7239 11.9361 11.3479 10.7961 12.4879C8.72005 14.5879 8.48005 17.8279 10.1001 20.1799H8.45605V22.0399H11.7921L19.3281 29.5759L20.0001 30.2239L28.1841 22.0399H31.5441V20.1799ZM12.1161 19.7119C10.4841 18.0799 10.4841 15.4399 12.1161 13.8079C13.7001 12.2359 16.4361 12.2359 18.0201 13.8079L20.0001 15.7999L21.9801 13.8199C23.6001 12.1999 26.2521 12.1879 27.8841 13.8199C29.5161 15.4519 29.5161 18.0919 27.8841 19.7239L27.4161 20.1919H21.9081L20.9241 21.7399L17.2041 15.1039L15.0201 20.1919H12.5841L12.1161 19.7119ZM19.9881 27.6079L14.4321 22.0519H16.2441L17.4201 19.3039L20.8161 25.3639L22.9281 22.0399H25.5441L19.9881 27.6079Z",
    fill: "#6A8860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.d72278b2c252a5b21f6c81bebb98f4ee.svg";
export { ForwardRef as ReactComponent };